import GooglePayButton from '@google-pay/button-react'
import React, { Component } from 'react'
import { PAYMENT_GATEWAY_FIRST_DATA } from '../../constants/app'

class GooglePay extends Component {
  getEnvironment () {
    return process.env.REACT_APP_FIRSTDATA_GOOGLEPAY_ENV
  }

  getPaymentRequest () {
    const { amount } = this.props

    return {
      apiVersion: 2,
      apiVersionMinor: 0,
      allowedPaymentMethods: [
        {
          type: 'CARD',
          parameters: {
            allowedAuthMethods: [
              'PAN_ONLY',
              'CRYPTOGRAM_3DS',
            ],
            allowedCardNetworks: [
              'MASTERCARD',
              'VISA',
            ],
          },
          tokenizationSpecification: {
            type: 'PAYMENT_GATEWAY',
            parameters: {
              gateway: 'firstdata',
              gatewayMerchantId: process.env.REACT_APP_FIRSTDATA_GOOGLEPAY_GMID,
            },
          },
        },
      ],
      merchantInfo: {
        merchantId: process.env.REACT_APP_FIRSTDATA_GOOGLEPAY_MID,
        merchantName: process.env.REACT_APP_FIRSTDATA_GOOGLEPAY_MN,
      },
      transactionInfo: {
        totalPriceStatus: 'FINAL',
        totalPriceLabel: 'Total',
        totalPrice: (amount / 100).toFixed(2),
        currencyCode: 'HKD',
        countryCode: 'HK',
      },
    }
  }

  getPrimaryTransactionParams (tokenizationData) {
    const { amount } = this.props

    const transactionAmount = {
      total: amount / 100,
      currency: 'HKD',
    }
    const walletPaymentMethod = {
      walletType: 'EncryptedGooglePayWalletPaymentMethod',
      encryptedGooglePay: tokenizationData,
    }

    return {
      requestType: 'WalletPreAuthTransaction',
      transactionAmount,
      walletPaymentMethod,
    }
  }

  async paymentSuccess (paymentData) {
    const { submit } = this.props
    const { paymentMethodData: { tokenizationData } } = paymentData

    try {
      const payload = this.getPrimaryTransactionParams(tokenizationData)

      submit({ payment: 'googlepay', payload, gateway: PAYMENT_GATEWAY_FIRST_DATA })
    } catch (ex) {

    }
  }

  render () {
    const { buttonClass } = this.props
    const environment = this.getEnvironment()
    const paymentRequest = this.getPaymentRequest()

    return <GooglePayButton buttonColor="white"
      buttonSizeMode="fill"
      buttonType="plain"
      className={ buttonClass }
      environment={ environment }
      paymentRequest={ paymentRequest }
      onLoadPaymentData={ this.paymentSuccess.bind(this) }
      style={ { display: 'block' } }/>
  }
}

export default GooglePay



// WEBPACK FOOTER //
// ./src/components/first-data/GooglePay.js